module.exports = __webpack_public_path__ + "img/91.8ba97e8d.jpg";